import React, { useEffect, useRef, useState } from 'react';
import { login, logout } from '../auth/authService';

// Signing in from the QR code on the printed sheet: /aanmeld#g=<username>&w=<password>.
// The credentials are in the fragment, which the browser never sends to the server. They are
// removed from the address bar (and history) straight away, then the beoordelaar is signed in
// (anyone already signed in on this phone is signed out first).
function Aanmeld() {
  const [fout, setFout] = useState('');
  const begin = useRef(false);

  useEffect(() => {
    if (begin.current) return; // once, also in React's development double run
    begin.current = true;

    const params = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const gebruikersnaam = params.get('g') || '';
    const wagwoord = params.get('w') || '';
    window.history.replaceState(null, '', '/aanmeld');

    if (!gebruikersnaam || !wagwoord) {
      setFout('Die skakel is onvolledig. Meld asseblief met jou gebruikersnaam en wagwoord aan.');
      return;
    }
    logout();
    login(gebruikersnaam, wagwoord).then(sukses => {
      if (sukses) {
        window.location.replace('/');
      } else {
        setFout('Kon nie aanmeld nie: die wagwoord op die strokie is dalk nie meer geldig nie. Vra die admin vir \'n nuwe een.');
      }
    });
  }, []);

  return (
    <div className="login-page">
      <div className="card login-card">
        {fout ? (
          <>
            <h2 className="login-title">Aanmelding</h2>
            <p className="login-error">{fout}</p>
            <a href="/login" className="btn btn-primary btn-block" style={{ textAlign: 'center', textDecoration: 'none' }}>
              Meld aan met gebruikersnaam
            </a>
          </>
        ) : (
          <h2 className="login-title">Meld aan...</h2>
        )}
      </div>
    </div>
  );
}

export default Aanmeld;
